<template>
    <div id="app" class="responsive-container">
        <div class="sticky-top bg-dark" style="box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;">
            <Navi />
        </div>
        <router-view />
        <div class="bg-dark">
            <!-- <Footer /> -->
        </div>
    </div>
</template>
<script>
import Navi from "./components/navi/Navbar.vue";
// import Footer from "./components/navi/Footer.vue";
export default {
    name: "App",
    components: {
        Navi,
        // Footer
    },
    created() {
        this.$store.dispatch('initDetechVisitors');
    },
    methods: {
        enterFullScreen() {
            const today = new Date().toISOString().split('T')[0];
            const lastFullScreenDate = localStorage.getItem('lastFullScreenDate');
            if (lastFullScreenDate !== today) {
                const element = document.documentElement;
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.webkitRequestFullscreen) {
                    element.webkitRequestFullscreen();
                } else if (element.msRequestFullscreen) {
                    element.msRequestFullscreen();
                }
                localStorage.setItem('lastFullScreenDate', today);
            }
        }
    }
};
</script>
<style>
.responsive-container {
    width: 100%;
    /* Full width for smaller screens (mobile) */
    padding-left: 0px;
    padding-right: 0;
}

@media (min-width: 768px) {
    .responsive-container {
        width: 80%;
        /* Container style only for medium and larger screens */
        margin-left: auto;
        margin-right: auto;
    }
}
</style>
